enum Page {
  planSelect = '/',
}

export default Page;
